'use strict';

var rUpper = /([A-Z])/g;

module.exports = function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
};


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/~/dom-helpers/util/hyphenate.js
// module id = 317
// module chunks = 0